import React from 'react';
import InsightDashboard from './InsightDashboard';
import FilterBar from './FilterBar/FilterBar';
import UpgradeAQInsightProNotification from '../Notifications/UpgradeAQInsightProNotification';
import LoadingModal from '../Components/LoadingModal';

const InsightApplication = function InsightApplication(): React.ReactElement {
  return (
    <>
      <LoadingModal />
      <FilterBar />
      <InsightDashboard />
      <UpgradeAQInsightProNotification />
    </>
  );
};

export default InsightApplication;
